<button style="margin: 10px; display: none;" mat-raised-button color="accent" (click)="openMetadataDialog()">{{displayString ? displayString : 'Edit Metadata'}}</button>
